const config = {
    IMGIX_BASE_URL: process.env.REACT_APP_IMGIX_URL,
    MEILISEARCH_HOST: process.env.REACT_APP_MEILISEARCH_HOST,
};

export default config;